/**
 * SEO 配置 - chat (Norsk)
 */

export default {
    chat: {
        title: 'AI Chat - Multimodell-assistent | WeryAI',
        description:
            'Chat med de beste AI-modellene på WeryAI. Sammenlign svar side ved side i flere vinduer. Generer bilder, videoer og musikk fra ett samlet AI-arbeidsområde.',
        keywords:
            'AI chat, AI assistent, multimodell chat, AI chatbot, sammenlign AI-modeller, side ved side AI chat, GPT alternativ, AI arbeidsområde, WeryAI',
        og_title: 'AI Chat - Multimodell-assistent | WeryAI',
        og_description:
            'Chat med de beste AI-modellene og sammenlign svar side ved side. Generer bilder, videoer og mer. Prøv gratis på WeryAI.',
        twitter_title: 'AI Chat - Multimodell-assistent | WeryAI',
        twitter_description:
            'Chat med de beste AI-modellene og sammenlign svar side ved side. Generer bilder, videoer og mer. Prøv gratis på WeryAI.',
    },
}
